import { Snackbar } from "@mui/material";
import React from "react";
import { useLanguageTheme } from "../../hooks/useLanguageTheme";
import CheckIcon from "../../assets/campaignBuilder/check_icon.svg";
import ErrorIcon from "../../assets/campaignBuilder/error_notification.svg";
import { useTranslation } from "react-i18next";
import { NotificationStatus } from "./content/steps/CampaignSetUpStep";

export const NotificationSnackBar = ({
  snackbarText,
  onClose,
  type,
  open,
}: {
  snackbarText: string;
  onClose: any;
  type: any;
  open: boolean;
}) => {
  const langTheme = useLanguageTheme();
  const { i18n } = useTranslation(["campaignBuilder"]);
  
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      ContentProps={{
        sx: {
          backgroundColor:
            type === NotificationStatus.SUCCESSFULL ? "#EDF7ED" : "#FDEDED",
          color:
            type === NotificationStatus.SUCCESSFULL ? "#1E4620" : "#5F2120",
          boxShadow: "none",
          fontFamily: langTheme.mainFont(),
          fontSize: "16px",
          fontWeight: 500,
          direction: i18n.dir(),
        },
      }}
      open={open}
      autoHideDuration={6000}
      onClose={() => onClose(false)}
      message={
        <div
          style={{
            display: "flex",
            gap: "12px",
          }}
        >
          <img
            src={
              type === NotificationStatus.SUCCESSFULL ? CheckIcon : ErrorIcon
            }
          />
          <div
            style={{
              lineHeight: "24px",
            }}
          >
            {snackbarText}
          </div>
        </div>
      }
    />
  );
};
